import { useEffect, useState } from "react";
import { getCertificateTypes } from "../api/certificateApi.js";

export const useCertificateTypes = () => {
  const [types, setTypes] = useState(null);

  useEffect(() => {
    getCertificateTypes()
      .then((res) => {
        console.log("Certificate Types Loaded:", res);
        setTypes(res);
      })
      .catch((err) => {
        console.error("Error fetching certificate types:", err);
      });
  }, []);

  return types;
};
